import BlockTitle from './BlockTitle.vue'

export default BlockTitle
